import { render, staticRenderFns } from "./VSSOButton.vue?vue&type=template&id=cc623ce4&scoped=true&"
import script from "./VSSOButton.vue?vue&type=script&lang=js&"
export * from "./VSSOButton.vue?vue&type=script&lang=js&"
import style0 from "./VSSOButton.vue?vue&type=style&index=0&id=cc623ce4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc623ce4",
  null
  
)

export default component.exports